var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59.7,30.3l-8-9C51.6,21.1,51.3,21,51,21h-7V8c0-0.6-0.4-1-1-1H20v2h22v13v15H19v2h23v4H22v2h21c0.6,0,1-0.4,1-1v-6V23 h6.6l6.2,7H50v2h8v12h2V31C60,30.7,59.9,30.5,59.7,30.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,41c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S17.3,41,14,41z M14,51c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S16.2,51,14,51z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,41c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S54.3,41,51,41z M51,51c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S53.2,51,51,51z "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 35,
    width: 3,
    height: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 47,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 47,
    r: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 43,
    width: 6,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 7,
    width: 17,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 15,
    width: 19,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 23,
    width: 19,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 32,
    width: 14,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 23,
    width: 4,
    height: 2
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.9605730d0446e5d325e3f0f571a80ac4.svg";
export { ForwardRef as ReactComponent };